export default __webpack_public_path__ + "static/media/5.d672e1cf.svg";